export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Full-Stack Web Devlopment',
        startYear: 'May 2022',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: '(RTMNU) Nagpur University',
        course: 'Bachelor of Engineering (ME)',
        startYear: '2018',
        endYear: '2021'
    },

    {
        id: 3,
        institution: 'G.H Raisoni Polytechnic, Nagpur',
        course: 'Diploma in Mechanical',
        startYear: '2016',
        endYear: '2018'
    },
   
    {
        id: 4,
        institution: 'Balaji Junior College,Nagpur',
        course: 'Higher Secondary Education',
        startYear: '2016',
        endYear: '2018'
    },
    
]